export enum deviceSortType
{
    name = 0,
    type = 1,
    status = 2
}